<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wBPAxR/tc-custom/9781497698819.jpg?1726871296712" alt="This image is the cover for the book My Father, His Daughter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Father, His Daughter
      </h1>
      <p class="bookDescription body article font2">
        <b>A life of one of Israel’s greatest heroes, as seen through his daughter’s eyes</b><br/><br/> Moshe Dayan was one of the greatest military leaders in Israel’s short history. A child of the first kibbutz movement in British Palestine, he went on to lead Israel to victory in the 1948 War of Independence and to liberate Jerusalem in the 1967 Six-Day War. Dayan was not only a soldier but a politician, an archaeologist, and a larger-than-life figure who helped shape the state of Israel.<br/>  <br/> In <i>My Father, His Daughter</i>, Yaël Dayan, who herself served in the Israeli Parliament, shares an uncensored look into her father’s life and her own conflicted relationship with him. With poignancy and candor, Dayan creates a profound yet nuanced profile of her father. She relates his strong national pride, his boldness in dealing with other world leaders, and his troubles at home to his disintegrating marriage and multiple affairs. As revealing as <i>My Father, His Daughter</i> is of the man behind the myth, it is also a snapshot of a loving relationship between Yaël and Moshe Dayan, and of a daughter’s admiration and respect for a complicated but loving father.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yaël Dayan
      </h2>
      
      <p class="authorDescription body article">Ya&euml;l Dayan is an Israeli author and political figure. Her father, Moshe Dayan, was the military leader who oversaw the stunning capture of Jerusalem during the Six-Day War. Like her father, Dayan served in the Israeli parliament, the Knesset, of which she was a member for ten years with the Labor Party. An outspoken activist, Dayan has been involved with Peace Now and other organizations fostering the peaceful coexistence of Israelis and Palestinians. She has written five novels, including&#160;<I>Three Weeks in October</I>, about the Yom Kippur War. Among Dayan&rsquo;s nonfiction works are&#160;<I>Israel Journal</I>, a memoir about the Six-Day War, and&#160;<I>My Father, His Daughter</I>, a biography of Moshe Dayan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60d243ea